require('../../lib/polyfill')
const omniture = require('../../lib/omniture')

const constants = require('./constants')

let commonContextParams = {}

function getUrlVars() {
  const vars = []
  const hashes = window.location.href
    .slice(window.location.href.indexOf('?') + 1)
    .split('&')
  for (let i = 0; i < hashes.length; i++) {
    const hash = hashes[i].split('=')
    const key = hash[0].toLowerCase()
    vars.push(key)
    vars[key] = hash[1]
  }
  return vars
}

function getCookie(name) {
  const nameEQ = `${name}=`
  const cookieList = document.cookie.split(';')
  for (let i = 0; i < cookieList.length; i++) {
    let cookie = cookieList[i]
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length)
    }
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length)
    }
  }
  return null
}

function getOmnitureCampaignQuery() {
  if (typeof window.s.t !== 'undefined') {
    return (
      window.s.Util.getQueryParam('cid') ||
      window.s.Util.getQueryParam('icid') ||
      window.s.Util.getQueryParam('scid')
    )
  }
  return null
}

function getPageContextObject(userObj, trackObj, prefix) {
  let utmParams = {}
  const userId =
    userObj && userObj.user_id
      ? userObj.user_id
      : constants.defaultUserObj.user_id
  const userEmail = userObj && userObj.email ? userObj.email : ''

  commonContextParams = {
    [prefix + '.user.id']: userId,
    [prefix + '.user.email']: userEmail,
    [prefix + '.longTermCookie']: getCookie('BRID'),
    [prefix + '.brid']: getCookie('BRID'), // having an alias for this value because data science uses both 'brid' and 'longTermCookie'
  }

  if (
    typeof window.s !== 'undefined' &&
    window.s.Util.getQueryParam('utm_source')
  ) {
    utmParams = {
      [prefix + '.utm.source']: window.s.Util.getQueryParam('utm_source'),
      [prefix + '.utm.campaign']: window.s.Util.getQueryParam('utm_campaign'),
      [prefix + '.utm.medium']: window.s.Util.getQueryParam('utm_medium'),
      [prefix + '.utm.content']: window.s.Util.getQueryParam('utm_content'),
      [prefix + '.utm.term']: window.s.Util.getQueryParam('utm_term'),
      [prefix + '.utm.name']: window.s.Util.getQueryParam('utm_name'),
    }
  }

  const pagePropertyParams = {
    // Page parameters
    [prefix + '.pageLoadTime']: omniture.getLoadTime(),
    [prefix + '.pagePercentViewed']: omniture.getPercentPageViewed(),
    [prefix + '.previousPage']: omniture.getPreviousPageViewed(
      trackObj.pageName
    ),
    // Page Campaigns
    [prefix + '.campaign']: getOmnitureCampaignQuery(),
  }

  return Object.assign(
    {},
    commonContextParams,
    trackObj,
    utmParams,
    pagePropertyParams
  )
}

function getCommonContextData() {
  return commonContextParams
}

module.exports = {
  getUrlVars,
  getCookie,
  getOmnitureCampaignQuery,
  getPageContextObject,
  getCommonContextData,
}
